// extracted by mini-css-extract-plugin
export default {"link":"AuthGoogle_link__XcO81","svg":"AuthGoogle_svg__iHrL1","span":"AuthGoogle_span__bfD91"};